import { Box, Typography, CircularProgress, MenuItem } from '@mui/material';
import {
  GeneralFormBox,
  HorizontalForm,
  CustomTextField,
  CustomSelect,
  CustomButton,
} from '../../../common/components';
import { REPORT_TYPES } from '../constants/statisticsConstants';

const StatisticsFilters = ({
  filters,
  loading,
  error,
  groups,
  legalEntities = [],
  onFilterChange,
  onSubmit,
}) => {
  const showFilters = filters.reportType !== 'score_ranking';

  return (
    <GeneralFormBox>
      <HorizontalForm>
        <CustomSelect
          label="Tipo de reporte"
          name="reportType"
          value={filters.reportType}
          onChange={onFilterChange}
          sx={{ width: '250px', mr: 2 }}
        >
          <MenuItem value="not_selected">Seleccione uno</MenuItem>
          {REPORT_TYPES.map((type) => (
            <MenuItem key={type.value} value={type.value}>
              {type.label}
            </MenuItem>
          ))}
        </CustomSelect>

        {showFilters && (
          <>
            <CustomTextField
              label="Fecha Desde"
              type="date"
              name="dateStart"
              value={filters.dateStart}
              onChange={onFilterChange}
              InputLabelProps={{ shrink: true }}
              sx={{ width: '200px', mr: 2 }}
            />
            <CustomTextField
              label="Fecha Hasta"
              type="date"
              name="dateEnd"
              value={filters.dateEnd}
              onChange={onFilterChange}
              InputLabelProps={{ shrink: true }}
              sx={{ width: '200px', mr: 2 }}
            />
            {filters.reportType === 'debt_balances' && (
              <CustomTextField
                label="Cuota Pura Actual"
                name="cuota_pura"
                value={filters.cuota_pura || ''}
                onChange={onFilterChange}
                sx={{ width: '200px', mr: 2 }}
              />
            )}

            <CustomSelect
              label="Grupo"
              name="group"
              value={filters.group}
              onChange={onFilterChange}
              sx={{ width: '200px', mr: 2 }}
            >
              <MenuItem value="all">TODOS</MenuItem>
              {groups.map((group) => (
                <MenuItem key={group.uuid} value={group.uuid}>
                  {group.name}
                </MenuItem>
              ))}
            </CustomSelect>

            <CustomTextField
              label="Orden"
              name="orderNumber"
              value={filters.orderNumber}
              onChange={onFilterChange}
              sx={{ width: '200px', mr: 2 }}
            />

            <CustomSelect
              label="Con casa"
              name="whitHouse"
              value={filters.whitHouse}
              onChange={onFilterChange}
              sx={{ width: '200px' }}
            >
              <MenuItem value="not_selected">TODOS</MenuItem>
              <MenuItem value="1">Si</MenuItem>
              <MenuItem value="0">No</MenuItem>
            </CustomSelect>
          </>
        )}
      </HorizontalForm>

      {error && (
        <Typography color="error" sx={{ mt: 2 }}>
          {error}
        </Typography>
      )}

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, my: 2 }}>
        <CustomButton
          variant="base"
          color="primary"
          onClick={onSubmit}
          disabled={filters.reportType === 'not_selected' || loading}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : 'Ver Reporte'}
        </CustomButton>
      </Box>
    </GeneralFormBox>
  );
};

export default StatisticsFilters;
